import React from 'react';
import { Segment } from 'semantic-ui-react';
import { graphql } from 'react-apollo';

import { AllClaims } from '../../../../queries/AllClaims';
import mapConnection from '../../../../utils/connectionMapper';
import ClaimsList from './../../../ClaimsListPage/ClaimsList';

const withClaimsQuery = graphql(AllClaims, {
  options: ({ filter, ...rest }) => {
    return {
      variables: {
        filter
      },
      notifyOnNetworkStatusChange: true
    };
  },
  props: ({ data: { claimsConnection, loading, error } }) => ({
    error,
    loading,
    claimsOptions: claimsConnection ? mapConnection(claimsConnection) : []
  })
});

const ClaimsListWithData = ({claimsOptions, loading, onAssignClick}) => (
  <Segment loading={loading}>
    {claimsOptions && (
      <ClaimsList
        allClaims={claimsOptions}
        assignButton={true}
        onAssign={onAssignClick}
      />
    )}
  </Segment>
);

export default withClaimsQuery(ClaimsListWithData);



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/ClaimSearch/ListWithData.js